import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=38ec3df2&scoped=true"
import script from "./course-list.vue?vue&type=script&lang=js"
export * from "./course-list.vue?vue&type=script&lang=js"
import style0 from "./course-list.vue?vue&type=style&index=0&id=38ec3df2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec3df2",
  null
  
)

export default component.exports